
// import api from '../../Images/icons/api.svg';

import ai from '../../Images/icons/ai.svg';
import Bootstrap from '../../Images/icons/bootstrap.svg';
import cs from '../../Images/icons/customersupport.svg';
import html from '../../Images/icons/html.svg';
import react from '../../Images/icons/react.svg';
import linux from '../../Images/icons/linux.svg';



const skills = [
    {
        icon: react,
        title: 'React JS',
        about: 'I can build web applications using ReactJS components ',
    },
    {
        icon: html,
        title: 'HTML & Css',
        about: 'I can make beautiful and responsive websites using HTML5 and CSS3',
    },
    {
        icon: Bootstrap,
        title: 'Bootstrap',
        about: 'I can make beautiful and responsive websites using Bootstrap 5',
    },
    {
        icon: ai,
        title: 'Machine Learning',
        about: 'I have knowledge of Machine learning, Data science and data preprocessing ',
    },
    {
        icon: cs,
        title: 'Customer support',
        about: 'I have experience in customer support and have 40+ typing speed',
    },
    {
        icon: linux,
        title: 'Linux operating system',
        about: 'I have experience of using linux operating system, can make basic troubleshooting',
    },

]
export default skills;